import React, { useState } from 'react';

const AccountRegisterGuide = () => {
  return (
    <div>
      <object id="pdf_content" width="100%" height="1500px" type="application/pdf" trusted="yes" application="yes" title="Account Registration Guide" data="./account_registration_guide.pdf?#zoom=100&scrollbar=1&toolbar=1&navpanes=1"></object>
    </div>
  );
}

export default AccountRegisterGuide;